import { useState } from "react";
import { supabase } from "../supabaseClient";
import { CURRENT_TOS_VERSION } from "../utils/constants";

export default function TosReacceptModal({ user, onAccepted }) {
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    if (!agreed) return;
    setLoading(true);
    await supabase
      .from("user_accounts")
      .update({ tos_version_accepted: CURRENT_TOS_VERSION })
      .eq("user_id", user.id);
    setLoading(false);
    onAccepted();
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <h2 style={title}>We've Updated Our Terms</h2>
        <p style={desc}>
          We've updated our Terms of Service and Privacy Policy to reflect new features including
          document uploads, employer download access, job matching, and our invitation system.
        </p>
        <div style={links}>
          <a href="/terms" target="_blank" rel="noopener noreferrer" style={link}>
            View Terms of Service
          </a>
          <a href="/privacy" target="_blank" rel="noopener noreferrer" style={link}>
            View Privacy Policy
          </a>
        </div>
        <label style={checkboxLabel}>
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            style={{ accentColor: "#d97706", flexShrink: 0, marginTop: 2 }}
          />
          <span style={checkboxText}>
            I have read and agree to the updated Terms of Service and Privacy Policy
          </span>
        </label>
        <button
          style={{ ...btn, opacity: agreed ? 1 : 0.4, cursor: agreed ? "pointer" : "not-allowed" }}
          disabled={!agreed || loading}
          onClick={handleAccept}
        >
          {loading ? "Saving..." : "Continue"}
        </button>
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed", inset: 0, zIndex: 9999,
  background: "rgba(0,0,0,0.85)",
  display: "flex", alignItems: "center", justifyContent: "center",
  padding: 20,
};

const modal = {
  background: "#111316", border: "1px solid #1e2022", borderRadius: 12,
  padding: "36px 40px", maxWidth: 480, width: "100%",
};

const title = {
  fontSize: 22, fontWeight: "bold", color: "#e8e4dc",
  margin: "0 0 14px", letterSpacing: "-0.3px",
};

const desc = {
  fontSize: 14, color: "#9a9490", lineHeight: 1.7, margin: "0 0 20px",
};

const links = {
  display: "flex", gap: 16, marginBottom: 24,
};

const link = {
  fontSize: 14, color: "#d97706", textDecoration: "none", fontWeight: "bold",
};

const checkboxLabel = {
  display: "flex", alignItems: "flex-start", gap: 10,
  cursor: "pointer", marginBottom: 20,
};

const checkboxText = {
  fontSize: 13, color: "#9a9490", lineHeight: 1.5,
};

const btn = {
  background: "#d97706", border: "none", color: "#0d0f10",
  padding: "12px 24px", fontSize: 15, fontWeight: "bold",
  borderRadius: 6, fontFamily: "inherit", width: "100%",
};
